export const TIMESHEET_STORE = 'TIMESHEET_STORE';
export const TIMESHEET_UPDATE = 'TIMESHEET_UPDATE';
export const TIMESHEET_DESTROY = 'TIMESHEET_DESTROY';
